/* eslint-disable @typescript-eslint/no-explicit-any */
export const getTrolleyStatus = (status: string | any) => {
  switch (status) {
    // Tote statuses
    case "Available":
    case "Empty - Available":
      return "#28A745";

    case "Loaded to Trolley":
      return "#007BFF";

    case "Unloaded from Trolley":
      return "#FBC02D";

    case "LOADING":
    case "Loading":
      return "#FFA500"; // Orange

    case "LOCATION_CHANGED_OUT":
    case "Closed":
      return "#007BFF"; // Blue

    case "UNLOADING":
    case "Unloading":
      return "#8A2BE2"; // Orange

    case "Empty":
    case "Empty - Not Available":
      return "#C0C0C0"; // Gray

    case "Unserviceable":
    case "Unserviceable - Awaiting Repair":
      return "#FF3B30"; // Red

    case "LOCATION_CHANGED_IN":
    case "Completed":
      return "#52a1c0"; // Teal

    default:
      return "#6C757D";
  }
};
